import React, { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import ClearSearchFilters from '@/components/atoms/search/clear-search-filter/clear-search-filters';
import styles from './slide-out-panel.module.scss';

type Props = {
  isShow: boolean;
  customClass?: string;
  title?: string;
  onClose: (a: boolean) => void;
  children: ReactNode;
};

export default function SlideOutPanel({ isShow, onClose, customClass, title, children }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function toggle(event: any) {
    onClose(event.target.isShow);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const translate = useTranslations();

  return (
    <div
      data-label={title}
      className={
        isShow
          ? `${styles[`slide-out-panel`]} ${styles[`slide-out-panel-visible`]}`
          : `${styles[`slide-out-panel`]}`
      }
    >
      <div
        className={
          isShow
            ? `${styles[`slide-out-panel-shadow`]} ${styles[`slide-out-panel-shadow-visible`]}`
            : `${styles[`slide-out-panel-shadow`]}`
        }
        onClick={toggle}
        aria-hidden="true"
      />
      <div
        className={
          isShow
            ? `${styles[`slide-out-panel-content`]} ${styles[`slide-out-panel-content-visible`]}`
            : `${styles[`slide-out-panel-content`]}`
        }
      >
        <div className={`${styles[`slide-out-panel-title`]} position-relative`}>
          <div className="w-75">
            <h3 className="mb-0">{title}</h3>
            <ClearSearchFilters displayText="Clear all" />
          </div>
          <hr />
          <button
            type="button"
            value="close"
            name="close"
            title="close"
            className={`${styles[`slide-out-panel-close`]} close border-0`}
            onClick={toggle}
          >
            Close
          </button>
        </div>

        <div className={`${styles[`slide-out-panel-children`]} ${styles[customClass]}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
